module.exports = __webpack_public_path__ + "img/IMG_8629_T_L_Wood.b92cc2fb.jpg";